import { create } from 'zustand';

interface LayoutState {
  /** A agenda recolhe o menu principal para ganhar largura, como o Google. */
  isNavCollapsed: boolean;
  setNavCollapsed: (collapsed: boolean) => void;
  /** A agenda ocupa a largura toda, sem o limite de leitura das outras telas. */
  isFullWidth: boolean;
  setFullWidth: (fullWidth: boolean) => void;
  /**
   * Conteudo sobre branco, sem o cinza de fundo. E o que o quadro do funil
   * pede: colunas cinza sobre pagina cinza tiravam a nitidez de tudo.
   */
  isPlainBackground: boolean;
  setPlainBackground: (plain: boolean) => void;
  /**
   * Secao aberta a mao no menu, presa ao caminho em que foi aberta. Fica no
   * store porque a largura da barra lateral depende dela: com submenu aberto
   * ela alarga.
   */
  manualSection: { path: string; section: string | null } | null;
  setManualSection: (choice: { path: string; section: string | null } | null) => void;
  /**
   * Menu do celular aberto. Mora aqui porque quem abre nem sempre e a barra
   * do topo: os atalhos do painel tambem levam para ele.
   */
  isMobileNavOpen: boolean;
  setMobileNavOpen: (open: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  isNavCollapsed: false,
  setNavCollapsed: (isNavCollapsed) => set({ isNavCollapsed }),
  isFullWidth: false,
  setFullWidth: (isFullWidth) => set({ isFullWidth }),
  isPlainBackground: false,
  setPlainBackground: (isPlainBackground) => set({ isPlainBackground }),
  manualSection: null,
  setManualSection: (manualSection) => set({ manualSection }),
  isMobileNavOpen: false,
  setMobileNavOpen: (isMobileNavOpen) => set({ isMobileNavOpen }),
}));
